import React, { useState, useEffect, useMemo } from 'react'
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  IconButton,
  Alert,
  Checkbox,
  FormControlLabel,
  useTheme,
  Tooltip,
  Snackbar,
  useMediaQuery,
  Menu
} from '@mui/material'
import {
  DataGrid,
  GridColumnMenuFilterItem,
  GridColumnMenuManageItem
  , GridMoreVertIcon
} from '@mui/x-data-grid'
import AddIcon from '@mui/icons-material/Add'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useSelector, useDispatch } from 'react-redux'
import { toast } from 'react-hot-toast'
import {
  useCreateListMutation,
  useGetListsQuery,
  useGetListLeadsQuery,
  useDeleteListMutation,
  usePostRowsMutation,
  useAddLeadsfromListMutation,
  useGetDownloadListMutation,
  useAddLeadstomListMutation,
  useAddEnrichListMutation
} from '../services/lists-service'
import { useGetCampaignsQuery } from '../services/campaign-service'
import { v4 as uuidv4 } from 'uuid'
import ConfirmationDialog from '../components/ConfirmationDialog'
import {
  Delete,
  Download
} from '@mui/icons-material'
import { downloadCsv } from 'src/utils/util.js'
import { ArrowLeftIconBlue } from 'src/assets/emailAccounts/connect/ArrowLeftIconBlue'
import { ArrowRight } from 'src/assets/general/ArrowRight'
import ListCsv from './ListCsv'
import { EACloseIcon } from 'src/assets/emailAccounts/EACloseIcon'
import { BulkUploadIcon } from 'src/assets/campaignDetailsLeads/BulkUploadIcon'
import ListDetailModal from 'src/components/leadsList/ListDetailModal.js'
import ExportCsvDialog from '@components/leadsFinder/ExportCsvDialog'
import { ExportIcon } from 'src/icons/export.js'
import { useNavigate } from 'react-router-dom'
import { setSeachData } from '../store/reducers/search.js'
import { useBillingUsageQuery } from 'src/services/billing-service.js'
import { useGetMeAndWorkspaceQuery } from '@services/user-service'
import HeaderWithPopoverUpdated from 'src/components/HeaderWithPopoverUpdated'
import { makeStyles } from '@mui/styles'
import { OffCheckboxCustomIcon } from 'src/assets/general/OffCheckboxCustomIcon.js'
import { OnCheckboxCustomIcon } from 'src/assets/general/OnCheckboxCustomIcon.js'

const useStyles = makeStyles((theme) => ({
  customDataGrid: {
    '& .MuiDataGrid-root': {
      backgroundColor: '#fff',
      border: '1px solid #E4E4E5'
    },

    '& .MuiDataGrid-columnHeader': {
      backgroundColor: '#F2F4F6',
      '&:focus': { outline: 'none' },
      '&:focus-within': { outline: 'none' },
      borderBottom: '1px solid #E4E4E5',
      '& .MuiDataGrid-columnHeaderTitle': {
        fontSize: '13px',
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: '0em',
        color: `${theme?.palette.primary.primaryText}`
      }
    },
    '& .MuiDataGrid-row': {
      border: '1px solid #E4E4E5'
    },
    '& .MuiDataGrid-cell': {
      padding: '8px',
      '&:focus': { outline: 'none' },
      '&:focus-within': { outline: 'none' },
      '& .MuiDataGrid-cellContent': {
        fontSize: '13px',
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: '0em',
        color: `${theme?.palette.primary.primaryText}`
      }
    }
  }
}))

const checkboxOfIcon = <OffCheckboxCustomIcon />
const checkboxOnIcon = <OnCheckboxCustomIcon />

const CustomCheckbox = (props) => (
  <Checkbox {...props} icon={checkboxOfIcon} checkedIcon={checkboxOnIcon} />
)

const CustomColumnMenu = (props) => {
  const itemProps = {
    colDef: props.colDef,
    onClick: props.hideMenu
  }
  return (
    <>
      <GridColumnMenuFilterItem {...itemProps} />
      <GridColumnMenuManageItem {...itemProps} />
    </>
  )
}

const LeadsListView = () => {
  const { data } = useGetMeAndWorkspaceQuery()
  const classes = useStyles()
  const [activeTab, setActiveTab] = useState('people')
  const [selectedList, setSelectedList] = useState(null)
  const [masterLists, setMasterLists] = useState(false)
  const [newListDialogOpen, setNewListDialogOpen] = useState(false)
  const [newListName, setNewListName] = useState('')
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedRowData, setSelectedRowData] = useState([])
  const [addToCampaignDialogOpen, setAddToCampaignDialogOpen] = useState(false)
  const [selectedCampaign, setSelectedCampaign] = useState('')
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25
  })
  const [rowClickedId, setRowClickedId] = useState(null)
  const [isLeadDetailDrawerOpen, setIsLeadDetailDrawerOpen] = useState(false)
  const [isConfirmingLeads, setIsConfirmingLeads] = useState(false)
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false)
  const [deleteRowConfirmationOpen, setDeleteRowConfirmationOpen] = useState(false)
  const [leadDuplicate, setLeadDuplicate] = useState(false)
  const [bounceCheck, setBounceCheck] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const storedWorkspace = JSON.parse(window.localStorage.getItem('workspace'))
  const [workspaceId, setWorkspaceId] = useState(storedWorkspace?._id || '')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme?.breakpoints.down('md'))
  const isSmallScreen = useMediaQuery(theme?.breakpoints.down('sm'))
  const [activeStep, setActiveStep] = useState(0)
  const [snackbarMsg, setSnackbarMsg] = useState('')
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [openListDialog, setOpenListDialog] = useState(false)
  const [verifyLeads, setVerifyLeads] = useState(false)
  const [listId, setListId] = useState(null)
  const { data: usage, refetch: refetchUsage } = useBillingUsageQuery()
  const leadsCredits = usage?.leadsCredits
  const dailyLeadLimit = usage?.dailyLeadLimit
  const bounceCredits = usage?.bounceCredit
  const [openVerified, setOpenVerified] = useState(false)
  const [verified, setVerified] = useState(false)
  const handleClickOpen = () => setOpenVerified(true)
  const handleClose = () => setOpenVerified(false)

  const handleCheckboxChange = (event) => {
    setVerified(event.target.checked)
  }

  const handleConfirmListDownload = () => {
    setOpenListDialog(true)
  }

  const handleCloseListDialog = () => {
    setOpenListDialog(false)
  }
  const [addLeadstomList] = useAddLeadstomListMutation()
  const [addEnrichList] = useAddEnrichListMutation()

  const [isImportLeadsDialogOpen, setIsImportLeadsDialogOpen] = useState(false)

  const handleClickOpenImportLeadsDialog = () => {
    setIsImportLeadsDialogOpen(true)
  }

  const handleCloseOpenImportLeadsDialog = () => {
    setIsImportLeadsDialogOpen(false)
    setActiveStep(0)
  }

  const onLeadsCreate = (createdLeads) => {
    // eslint-disable-next-line
    if (createdLeads) setLeadCreated(true)
    setActiveStep(0)
    setIsImportLeadsDialogOpen(false)
  }
  // eslint-disable-next-line
  const [getDownloadList, { isLoading: isDownloadCSVLoading }] = useGetDownloadListMutation()
  // Get current workspace
  const currentWorkspace = useSelector((state) => state.workspace)
  useEffect(() => {
    if (currentWorkspace?._id) {
      setWorkspaceId(currentWorkspace._id)
    }
  }, [currentWorkspace])

  // Query parameters
  const buildQueryParams = (params) => {
    return Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )
  }

  const [limit, setLimit] = useState(10)
  const handleShowMoreOrLess = () => {
    if (limit >= (listsData?.totalDocs || 0)) {
      setLimit(10)
    } else {
      setLimit(prev => prev + 10)
    }
  }

  const listsQueryParams = useMemo(() => {
    return buildQueryParams({
      ...(searchTerm ? { search: searchTerm } : {}),
      offset: 0,
      limit,
      workspaceId,
      alignment: activeTab === 'people' ? 'People' : 'Companies'
    })
  }, [searchTerm, activeTab, workspaceId, limit])

  const leadsQueryParams = selectedList
    ? {
        listId: selectedList,
        params: buildQueryParams({
          ...(searchTerm && { search: searchTerm }),
          offset: paginationModel.page * paginationModel.pageSize,
          limit: paginationModel.pageSize
        })
      }
    : null
  const {
    data: listsData,
    isLoading: listsLoading,
    refetch: refetchLists
  } = useGetListsQuery(listsQueryParams)
  // const selectedListData = listsData?.docs?.find((list) => list._id === selectedList)
  const {
    data: fetchedLeads = { docs: [] },
    isLoading: leadsLoading,
    refetch: refetchLeads
  } = useGetListLeadsQuery(leadsQueryParams, {
    skip: !selectedList
  })

  const handleDownloadCsvClick = async () => {
    try {
      const result = await addLeadstomList({
        listId,
        leads: selectedRows,
        workspaceId,
        activeTab
      }).unwrap()
      refetchLeads()
      setOpenListDialog(false)
      toast.success(`${result?.message?.modifiedCount} leads added in the list`)
    } catch (error) {
      console.error('Failed to add leads to list:', error)
    }
  }

  const handleEnrichLeadsList = async () => {
    try {
      await addEnrichList({
        listId: selectedList,
        leads: selectedRows,
        workspaceId,
        verified,
        activeTab
      }).unwrap()
      refetchLeads()

      if (selectedListLeads?.total > leadsCredits) {
        toast.error(`You don't have enough lead balance to select ${selectedListLeads?.total} leads`)
        return
      }

      if (selectedListLeads?.total > dailyLeadLimit) {
        toast.error(`You don't have enough daily lead balance to select ${selectedListLeads?.total} leads`)
        return
      }

      if (verified && selectedListLeads?.total > bounceCredits) {
        toast.error('Insufficient Lead Verification Credits: Please add more credits')
        return
      }

      setOpenVerified(false)
      refetchUsage()
      toast.success(`Enrichment process is started for ${selectedListLeads?.total} leads`)
    } catch (error) {
      console.error('Failed to add leads to list:', error)
    }
  }
  const [selectedListLeads, setSelectedListLeads] = useState([])
  useEffect(() => {
    if (fetchedLeads?.docs) {
      setSelectedListLeads(fetchedLeads)
    }
  }, [fetchedLeads])

  const exactTotalCount = selectedListLeads?.total || 0

  const { data: campaigns } = useGetCampaignsQuery({
    unibox: true,
    option: true,
    workspaceId
  })

  // Mutations
  const [createList, { isLoading: isCreating }] = useCreateListMutation()
  const [deleteList] = useDeleteListMutation()
  const [postRows] = usePostRowsMutation()
  // const [addLeadsToList] = useAddLeadsToListMutation()
  const [addLeadsfromList] = useAddLeadsfromListMutation()

  const lists = listsData?.docs || []
  const peopleLists = useMemo(
    () => lists.filter(list => list.isCompanyList === false),
    [lists]
  )

  const companyLists = useMemo(() => {
    return lists
      .filter(list => list.isCompanyList === true)
      .sort((a, b) => (b.masterLists === true ? 1 : 0) - (a.masterLists === true ? 1 : 0))
  }, [lists])

  const displayedLists = useMemo(
    () => (activeTab === 'people' ? peopleLists : companyLists),
    [activeTab, peopleLists, companyLists]
  )

  useEffect(() => {
    setSelectedList(null)
    setSelectedListLeads([])
  }, [activeTab])

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 200,
      valueGetter: (params) => `${params.row.first_name || ''} ${params.row.last_name || ''}`
    },
    {
      field: 'company',
      headerName: 'Company',
      width: 200,
      valueGetter: (params) => params.row.company || 'N/A'
    },
    { field: 'email', headerName: 'Email', width: 250 },
    { field: 'title', headerName: 'Title', width: 200 },
    { field: 'country', headerName: 'Country', width: 150 },
    { field: 'state', headerName: 'State', width: 150 },
    { field: 'city', headerName: 'City', width: 150 }
  ]

  const companyColumns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 200,
      valueGetter: (params) => `${params.row.name || ''}`
    },
    {
      field: 'website',
      headerName: 'Website',
      width: 200,
      valueGetter: (params) => params.row.website || 'N/A'
    },
    { field: 'domain', headerName: 'Domain', width: 250 },
    { field: 'linkedin_url', headerName: 'LinkedinUrl', width: 200 },
    { field: 'industry', headerName: 'Industry', width: 150 },
    { field: 'country', headerName: 'Country', width: 150 },
    { field: 'state', headerName: 'State', width: 150 },
    { field: 'city', headerName: 'City', width: 150 },
    { field: 'employee_count', headerName: 'EmployeeCount', width: 150 },
    { field: 'annual_revenue', headerName: 'AnnualRevenue', width: 150 },
    { field: 'founded_year', headerName: 'FoundedYear', width: 150 }

  ]

  const handleSearch = (event) => {
    setSearchTerm(event.target.value)
    setPaginationModel({ ...paginationModel, page: 0 })
  }

  const handleNewList = async () => {
    try {
      const newListNameStr = String(newListName || '')
      if (newListNameStr.length > 45) {
        toast.error('List name cannot exceed 45 characters')
        return
      }
      await createList({
        name: newListName,
        workspaceId,
        activeTab
      }).unwrap()
      toast.success('The new list has been created successfully.')
      setNewListDialogOpen(false)
      setNewListName('')
      refetchLists()
    } catch (error) {
      toast.error(error.data?.error?.message || 'Failed to create list')
    }
  }

  const handleDeleteConfirmation = () => {
    setDeleteConfirmationOpen(true)
  }

  const handleRowDeleteConfirmation = () => {
    setDeleteRowConfirmationOpen(true)
  }

  const handleConfirmedDelete = async () => {
    try {
      await deleteList({ id: selectedList, activeTab }).unwrap()
      toast.success('The list has been deleted successfully.')
      setSelectedList(null)
      setDeleteConfirmationOpen(false)
      refetchLists()
      refetchLeads()
      setSelectedListLeads([])
    } catch (error) {
      toast.error(error.data?.error?.message || 'Failed to delete list')
    }
  }

  const handleConfirmedPostRow = async () => {
    if (!selectedList || !selectedRows) {
      toast.error('Both selectedList and selectedRows are required.')
      return
    }
    try {
      const response = await postRows({ selectedList, selectedRows, activeTab }).unwrap()
      toast.success(response?.deletedRows?.acknowledged ? 'Rows Deleted successfully' : '')
      refetchLeads()
      setDeleteRowConfirmationOpen(false)
    } catch (error) {
      toast.error(error.data?.error?.message || 'Failed to post rows')
    }
  }

  const handleAddToCampaign = async () => {
    try {
      const batchId = uuidv4()
      await addLeadsfromList({
        campaignId: selectedCampaign,
        leads: selectedRowData,
        checkDuplicates: leadDuplicate,
        bounceCheck,
        workspaceId,
        batchId
      }).unwrap()

      setAddToCampaignDialogOpen(false)
      setSelectedCampaign('')
      refetchLeads()
      refetchLists()
      toast.loading(`${selectedRows.length} Leads Adding to campaign`)
    } catch (error) {
      toast.error(error.data?.error?.message || 'Failed to add leads to campaign')
    }
  }
  const handleDownloadSelectedLeads = async (selectRow) => {
    if (selectRow) {
      try {
        const filteredData = await getDownloadList(selectedList).unwrap()
        downloadCsv('listData', filteredData?.data, null)
      } catch (error) {
        console.error('Error fetching download list:', error)
      }
    } else {
      const excludedFields = [
        '_id',
        'workspaceId',
        '__v',
        'batchId',
        'createdAt',
        'csvId',
        'deleted',
        'list',
        'queryHash',
        'updatedAt'
      ]

      const filteredData = selectedRowData.map(row => {
        const cleaned = { ...row }
        excludedFields.forEach(field => delete cleaned[field])
        return cleaned
      })

      if (filteredData.length === 0) {
        return
      }

      downloadCsv('listData', filteredData, null)
    }
  }

  const handleLeadDetailDrawerClose = () => {
    setIsLeadDetailDrawerOpen(false)
    setRowClickedId(null)
  }

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const serachDataFromRedux = useSelector((state) => state?.search)

  const handleNavigateToLeadFinder = () => {
    if (selectedRowData.length === 0) {
      toast.error('Please select at least one lead to proceed.')
      return
    }

    // Extract relevant data for filtering
    const filterData = selectedRowData.map(row => ({
      primary_domain: row.domain,
      name: row.name || row.company_name
    }))

    const validLinks = []
    filterData.forEach(item => {
      [item.primary_domain, item.name].forEach(value => {
        if (value && value !== 'null' && value !== 'undefined') {
          validLinks.push(value)
        }
      })
    })

    // Dispatch the search data
    dispatch(
      setSeachData({
        // current search data from Redux
        ...serachDataFromRedux,
        leads: [],
        filter: {
          link: validLinks
        },
        shouldTrigger: true,
        selectedRows: true,
        alignment: 'People' // Use People Search
      })
    )

    // Navigate to the leadfinder page
    navigate('/leadfinder')
  }

  const dataGridProps = {
    rows: selectedListLeads?.docs || [],
    columns: activeTab === 'people' ? columns : companyColumns,
    checkboxSelection: true,
    onRowSelectionModelChange: (newSelectedIds) => {
      setSelectedRows(newSelectedIds)
      const selectedData = (selectedListLeads?.docs || []).filter(row => newSelectedIds.includes(row._id))
      setSelectedRowData(selectedData)
    },
    rowSelectionModel: selectedRows,
    loading: leadsLoading,
    pagination: true,
    paginationMode: 'server',
    pageSizeOptions: [25, 50, 100],
    paginationModel: {
      page: paginationModel.page,
      pageSize: paginationModel.pageSize
    },
    rowCount: exactTotalCount,
    onPaginationModelChange: (newModel) => {
      setPaginationModel(newModel)
    },
    getRowId: (row) => row._id,
    onRowClick: (params) => {
      setRowClickedId(params.row._id)
      setIsLeadDetailDrawerOpen(true)
    },
    disableRowSelectionOnClick: true,
    slots: {
      baseCheckbox: CustomCheckbox,
      columnMenu: CustomColumnMenu,
      columnMenuIcon: () => null,
      pagination: (props) => {
        if (!selectedListLeads?.docs?.length) return null
        const currentPage = paginationModel.page
        const pageSize = paginationModel.pageSize
        const from = exactTotalCount === 0 ? 0 : currentPage * pageSize + 1
        const to = Math.min((currentPage + 1) * pageSize, exactTotalCount)
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', sm: 'row', md: 'row', lg: 'row', xl: 'row', xxl: 'row' }
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography
                variant='body2'
                sx={{
                  fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' },
                  fontWeight: 500,
                  lineHeight: '16px',
                  letterSpacing: '0em',
                  color: `${theme?.palette.primary.primaryText}`
                }}
              >
                Rows per page:
              </Typography>
              <Select
                value={pageSize}
                onChange={(e) => {
                  setPaginationModel((prev) => ({
                    ...prev,
                    pageSize: Number(e.target.value),
                    page: 0
                  }))
                }}
                size='small'
                // sx={{ minWidth: 50, mr: 1 }}
                sx={{
                  width: { xs: 55, sm: 55, md: 55, lg: 55, xl: 55, xxl: 55 },
                  color: `${theme?.palette.primary.primaryText}`,
                  fontWeight: 500,
                  lineHeight: '16px',
                  letterSpacing: '0em',
                  fontSize: '0.75rem',
                  mr: 1,
                  '& .MuiSelect-select': {
                    py: 0.5,
                    px: 1,
                    minHeight: 'unset'
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '4px 8px'
                  }
                }}
              >
                {[25, 50, 100].map((size) => (
                  <MenuItem key={size} value={size}>
                    {size}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography
                variant='body2' color='text.secondary'
                sx={{
                  fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' },
                  color: `${theme?.palette.primary.primaryText}`,
                  fontWeight: 500,
                  lineHeight: '16px',
                  letterSpacing: '0em'
                }}
              >
                {`${from}-${to} of ${exactTotalCount}`}
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton
                  onClick={() => setPaginationModel((prev) => ({ ...prev, page: prev.page - 1 }))}
                  disabled={currentPage === 0}
                >
                  <ChevronLeftIcon />
                </IconButton>
                <IconButton
                  onClick={() => setPaginationModel((prev) => ({ ...prev, page: prev.page + 1 }))}
                  disabled={to >= exactTotalCount}
                >
                  <ChevronRightIcon />
                </IconButton>
              </Box>
            </Box>
          </Box>
        )
      },
      noRowsOverlay: () => (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            minHeight: 300,
            width: '100%',
            textAlign: 'center',
            color: `${theme?.palette.primary.primaryText}`,
            fontWeight: 500,
            lineHeight: '16px',
            letterSpacing: '0em'
          }}
        >
          {leadsLoading
            ? (
              <CircularProgress size={24} />
              )
            : selectedList
              ? (
                  'No leads found'
                )
              : (
                  'Select a list to view leads'
                )}
        </Box>
      )
    }
    // hideFooterSelectedRowCount: true,
  }
  const handleWorkspaceChange = (newWorkspace) => {
    // setWorkspace(newWorkspace);
  }
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  return (
    // <Box
    //   sx={{
    //     // width: '96vw',
    //     height: '100%',
    //     backgroundColor: '#F8FAFC',
    //     pl: 2,
    //     overflow: 'hidden'
    //   }}
    // >
    //   {!isMobile && <HeaderWithPopoverUpdated
    //     title='Lists'
    //     onWorkspaceChange={handleWorkspaceChange}
    //     selectedTimeline={data?.workspace}
    //   />}
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        height: '100%',
        overflowY: 'scroll',
        '&::-webkit-scrollbar': {
          display: 'none' // Hide scrollbar for WebKit browsers
        }
      }}
    >
      <Box
        sx={{
          width: '96%',
          // height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row',
            pb: 2
          }}
        >
          {!isMobile && <HeaderWithPopoverUpdated
            title='Lists'
            onWorkspaceChange={handleWorkspaceChange}
            selectedTimeline={data?.workspace}
                        />}
        </Box>
        <Box
          sx={{
            display: 'flex',
            height: { xs: '80vh', sm: '86vh', md: '88vh', lg: '88vh', xl: '91vh', xxl: '96vh' },
            width: 'calc(100% + -10px)',
            margin: 0,
            padding: 0,
            justifyContent: 'space-between'
            // mt: 2,
            // ml: 2
          }}
        >
          {/* Left Sidebar */}

          <Box
            sx={{
              width: '20%',
              maxWidth: '20%',
              bgcolor: 'white',
              borderRight: '1px solid #E4E4E5',
              p: 2,
              flexDirection: 'column',
              // position: 'sticky',
              // top: 0,
              // height: {xs: '80vh', sm: '80vh', md: '80vh', lg: '80vh', xl: '80vh', xxl: '80vh'},
              overflowY: 'auto',
              // flexShrink: 0,
              borderRadius: '12px',
              display: { xs: 'none', sm: 'flex' },
              height: '100%'
            }}
          >
            {/* Sidebar content... */}
            <Box sx={{ mb: 2 }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: { xs: 0, sm: 0, md: 2, lg: 2, xl: 2, xxl: 2 }
                }}
              >
                {!isMobile && (
                  <Typography
                    sx={{
                      fontSize: { xs: '12px', sm: '12px', md: '14px', lg: '14px', xl: '14px', xxl: '14px' },
                      fontWeight: 700,
                      color: `${theme?.palette.primary.primaryText}`,
                      // fontWeight: 500,
                      lineHeight: '16px',
                      letterSpacing: '0em'
                    }}
                  >
                    View:
                  </Typography>)}
                {/* Dropdown Select instead of Tab Switch */}
                <FormControl sx={{ width: { xs: '80%', sm: '80%', md: '80%', lg: '60%', xl: '60%', xxl: '60%' } }}>
                  <Select
                    value={activeTab}
                    onChange={(e) => setActiveTab(e.target.value)}
                    displayEmpty
                    sx={{
                      bgcolor: 'white',
                      borderRadius: 1,
                      fontSize: '14px',
                      fontWeight: 500,
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#E4E4E5'
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main
                      },
                      '& .MuiSelect-select': {
                        py: 1,
                        px: 2,
                        fontSize: '14px',
                        fontWeight: 500,
                        color: `${theme?.palette.primary.primaryText}`,
                        lineHeight: '16px',
                        letterSpacing: '0em'
                      }
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          borderRadius: 1,
                          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                          mt: 0.5
                        }
                      }
                    }}
                  >
                    <MenuItem
                      value='people'
                      sx={{
                        fontSize: '14px',
                        color: `${theme?.palette.primary.primaryText}`,
                        fontWeight: 500,
                        lineHeight: '16px',
                        letterSpacing: '0em',
                        '&:hover': {
                          bgcolor: '#F2F4F6'
                        },
                        '&.Mui-selected': {
                          bgcolor: theme.palette.primary.main,
                          color: 'white',
                          '&:hover': {
                            bgcolor: theme.palette.primary.dark
                          }
                        }
                      }}
                    >
                      People
                    </MenuItem>
                    <MenuItem
                      value='company'
                      sx={{
                        fontSize: '14px',
                        color: `${theme?.palette.primary.primaryText}`,
                        fontWeight: 500,
                        lineHeight: '16px',
                        letterSpacing: '0em',
                        '&:hover': {
                          bgcolor: '#F2F4F6'
                        },
                        '&.Mui-selected': {
                          bgcolor: theme.palette.primary.main,
                          color: 'white',
                          '&:hover': {
                            bgcolor: theme.palette.primary.dark
                          }
                        }
                      }}
                    >
                      Company
                    </MenuItem>
                  </Select>
                </FormControl>
                <IconButton
                  onClick={() => setNewListDialogOpen(true)}
                  size='small'
                  sx={{ color: theme.palette.primary.main }}
                >
                  <AddIcon />
                </IconButton>
              </Box>

              {/* Tab Switch */}
              {/* <Box
                sx={{
                  display: 'flex',
                  bgcolor: '#F2F4F6',
                  borderRadius: 1,
                  p: 0.5,
                  mb: 2
                }}
              >
                <Button
                  onClick={() => setActiveTab('people')}
                  sx={{
                    flex: 1,
                    py: 0.5,
                    px: 2,
                    fontSize: '14px',
                    fontWeight: activeTab === 'people' ? 600 : 400,
                    color: activeTab === 'people' ? theme.palette.primary.main : '#8181B0',
                    bgcolor: activeTab === 'people' ? 'white' : 'transparent',
                    borderRadius: 0.5,
                    boxShadow: activeTab === 'people' ? '0px 1px 2px rgba(0, 0, 0, 0.08)' : 'none',
                    '&:hover': {
                      bgcolor: activeTab === 'people' ? 'white' : 'rgba(255, 255, 255, 0.5)'
                    }
                  }}
                >
                  People
                </Button>
                <Button
                  onClick={() => setActiveTab('company')}
                  sx={{
                    flex: 1,
                    py: 0.5,
                    px: 2,
                    fontSize: '14px',
                    fontWeight: activeTab === 'company' ? 600 : 400,
                    color: activeTab === 'company' ? theme.palette.primary.main : '#8181B0',
                    bgcolor: activeTab === 'company' ? 'white' : 'transparent',
                    borderRadius: 0.5,
                    boxShadow: activeTab === 'company' ? '0px 1px 2px rgba(0, 0, 0, 0.08)' : 'none',
                    '&:hover': {
                      bgcolor: activeTab === 'company' ? 'white' : 'rgba(255, 255, 255, 0.5)'
                    }
                  }}
                >
                  Company
                </Button>
              </Box> */}
              {/* <FormControl fullWidth size='small'>
                <Select
                  labelId='demo-simple-select-label'
                  id='demo-simple-select'
                  value={activeTab}
                  onChange={(e) => setActiveTab(e.target.value)}
                  sx={{
                    fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' },
                    '& .MuiOutlinedInput-input': {
                      padding: '10px 8px' // reduce internal padding
                    }
                  }}
                >
                  <MenuItem
                    value='people' sx={{
                      fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' }
                    }}
                  >People
                  </MenuItem>
                  <MenuItem
                    value='company' sx={{
                      fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' }
                    }}
                  >Company
                  </MenuItem>
                </Select>
              </FormControl> */}
            </Box>

            <TextField
              placeholder='Search lists...'
              value={searchTerm}
              onChange={handleSearch}
              variant='outlined'
              size='small'
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#E4E4E5',
                    borderRadius: '8px'
                  },
                  '&:hover fieldset': {
                    borderColor: theme.palette.primary.main
                  }
                },
                mb: 2
              }}
            />

            {listsLoading
              ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                  <CircularProgress size={24} />
                </Box>
                )
              : displayedLists.length === 0
                ? (
                  <Alert severity='info' sx={{ mt: 2 }}>
                    No lists found
                  </Alert>
                  )
                : (
                  <List sx={{ pt: 0 }}>
                    {displayedLists.map((list) => (
                      <ListItem
                        key={list._id}
                        onClick={() => {
                          setSelectedList(list?._id)
                          setMasterLists(list?.masterLists)
                        }}
                        sx={{
                          // borderRadius: 1,
                          mb: 1,
                          cursor: 'pointer',
                          bgcolor: selectedList === list._id ? '#F2F4F6' : 'transparent',
                          '&:hover': { bgcolor: '#F2F4F6' },
                          pt: '8px',
                          pb: '8px',
                          pl: { xs: '0px', sm: '5px', md: '16px' },
                          pr: { xs: '0px', sm: '5px', md: '16px' },
                          border: '1px solid #E4E4E5',
                          borderRadius: '8px'
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                // fontSize: '14px',
                                fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' },
                                color: `${theme?.palette.primary.primaryText}`,
                                fontWeight: 500,
                                lineHeight: '16px',
                                letterSpacing: '0em'
                              }}
                            >
                              {list.name}{' '}
                              {list.masterLists && (
                                <Typography
                                  component='span'
                                  sx={{
                                    // fontSize: '12px',
                                    fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' },
                                    color: `${theme?.palette.primary.primaryText}`,
                                    fontWeight: 500,
                                    lineHeight: '16px',
                                    letterSpacing: '0em'
                                  }}
                                >
                                  (not editable)
                                </Typography>
                              )}
                            </Typography>
                          }
                          secondary={
                            selectedList === list?._id && (
                              <Typography sx={{
                                fontSize: '13px',
                                color: `${theme?.palette.primary.primaryText}`,
                                fontWeight: 500,
                                lineHeight: '16px',
                                letterSpacing: '0em'
                              }}
                              >
                                {`${selectedListLeads?.total || 0} leads`}
                              </Typography>
                            )
                          }
                        />
                        <ChevronRightIcon sx={{ color: '#8181B0', fontSize: { xs: '20px', sm: '20px', md: '22px' } }} />
                      </ListItem>
                    ))}
                  </List>
                  )}
            {displayedLists.length > 10 && (
              <Button variant='outlined' onClick={handleShowMoreOrLess}>
                {limit >= listsData?.totalDocs ? 'Show less' : 'Show more'}
              </Button>
            )}
          </Box>

          {/* Main Content */}
          <Box sx={{
            flexGrow: 1,
            // overflowY: 'auto',
            maxWidth: { xs: '100%', sm: '79%' },
            borderRadius: '12px',
            // p: 3,
            pt: 3,
            pl: 3,
            pr: 3,
            pb: 0.1,
            backgroundColor: '#fff',
            mb: 4,
            height: '100%'
          }}
          >
            {/* Header */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 1,
                // flexDirection: { xs: 'column', md: 'row' },
                width: '100%'
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: '16px', md: '20px' },
                  fontWeight: 700,
                  color: theme.palette.primary.primaryText,
                  display: 'flex',
                  mb: 'inherit'
                }}
              >
                {selectedList
                  ? (
                    <>
                      <Typography
                        sx={{
                          fontSize: { xs: '12px', sm: '12px', md: '13px', lg: '16px', xl: '16px', xxl: '16px' },
                          fontWeight: 700,
                          color: theme.palette.primary.primaryText,
                          lineHeight: '16px',
                          letterSpacing: '0em',
                          mr: 1
                        }}
                      >
                        {lists?.find((l) => l._id === selectedList)?.name}{' '}
                      </Typography>
                      {lists?.find((l) => l._id === selectedList)?.masterLists && (
                        <Typography
                          component='span'
                          sx={{
                            // fontSize: '12px',
                            // fontWeight: 400,
                            color: 'text.secondary',
                            fontSize: { xs: '12px', sm: '12px', md: '13px', lg: '16px', xl: '16px', xxl: '16px' },
                            fontWeight: 500,
                            lineHeight: '16px',
                            letterSpacing: '0em'
                          }}
                        >
                          (not editable)
                        </Typography>
                      )}
                    </>
                    )
                  : (
                      'Select a List'
                    )}

              </Typography>

              <Dialog
                open={isImportLeadsDialogOpen}
                onClose={handleCloseOpenImportLeadsDialog}
                fullWidth
                maxWidth='md'
                sx={{ backgroundColor: 'rgba(4, 4, 30, 0.5)' }}
                fullScreen={isMobile}
              >
                <DialogTitle>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      width: '100%'
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        flexDirection: 'column'
                      }}
                    >
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography
                          sx={{
                            fontSize: '20px',
                            fontWeight: 700,
                            lineHeight: '28px',
                            color: `${theme?.palette.primary.primaryText}`
                          }}
                        >
                          Import Leads
                        </Typography>
                        {activeStep !== 0 && (
                          <>
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                mr: 0.5
                              }}
                            >
                              <ArrowRight />
                            </Box>
                          </>
                        )}
                        {activeStep === 1
                          ? (
                            <>
                              <Typography
                                sx={{
                                  fontSize: '16px',
                                  fontWeight: 700,
                                  lineHeight: '28px',
                                  color: '#8181B0'
                                }}
                              >
                                Import CSV File
                              </Typography>
                            </>
                            )
                          : activeStep === 2
                            ? (
                              <>
                                <Typography
                                  sx={{
                                    fontSize: '16px',
                                    fontWeight: 700,
                                    lineHeight: '28px',
                                    color: '#8181B0'
                                  }}
                                >
                                  Use Lead Finder
                                </Typography>
                              </>
                              )
                            : activeStep === 3
                              ? (
                                <>
                                  <Typography
                                    sx={{
                                      fontSize: '16px',
                                      fontWeight: 700,
                                      lineHeight: '28px',
                                      color: '#8181B0'
                                    }}
                                  >
                                    Input Emails Manually
                                  </Typography>
                                </>
                                )
                              : activeStep === 4
                                ? (
                                  <>
                                    <Typography
                                      sx={{
                                        fontSize: '16px',
                                        fontWeight: 700,
                                        lineHeight: '28px',
                                        color: '#8181B0'
                                      }}
                                    >
                                      Utilize Google Sheets
                                    </Typography>
                                  </>
                                  )
                                : null}
                      </Box>

                      {activeStep === 0
                        ? (
                          <>
                            <Typography
                              sx={{
                                fontSize: '13px',
                                fontWeight: 400,
                                lineHeight: '20px',
                                color: '#8181B0',
                                mt: 1
                              }}
                            >
                              Choose one of the methods listed below to effortlessly import leads.
                            </Typography>
                          </>
                          )
                        : (
                          <>
                            <Typography
                              sx={{
                                fontSize: '13px',
                                fontWeight: 400,
                                lineHeight: '20px',
                                color: '#8181B0',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                mt: 1,
                                cursor: 'pointer'
                              }}
                              onClick={() => {
                                setActiveStep(0)
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  mr: 1
                                }}
                              >
                                <ArrowLeftIconBlue color='#8181B0' />
                              </Box>
                              Select a Different Method
                            </Typography>
                          </>
                          )}
                    </Box>
                    <IconButton
                      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                      onClick={handleCloseOpenImportLeadsDialog}
                    >
                      <EACloseIcon />
                    </IconButton>
                  </Box>
                </DialogTitle>
                <DialogContent>
                  {activeStep === 0
                    ? (
                      <>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexDirection: { xs: 'column', md: 'row' },
                            rowGap: 2
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: { xs: 'center', md: 'flex-start' },
                              cursor: 'pointer',
                              width: { xs: '70%', sm: '40%', md: '100%' },
                              p: 3,
                              border: '1px solid #00AA38',
                              flexDirection: 'column',
                              height: '100%',
                              backgroundColor: '#fff',
                              borderRadius: '12px',
                              boxShadow: '0px 12px 15px 0px #4B71970D'
                            }}
                            onClick={() => {
                              setActiveStep(1)
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              <BulkUploadIcon />
                            </Box>

                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: 700,
                                  lineHeight: '26px',
                                  color: `${theme?.palette.primary.primaryText}`,
                                  mt: 1.5
                                }}
                              >
                                Upload CSV
                              </Typography>
                            </Box>
                          </Box>

                        </Box>
                      </>
                      )
                    : activeStep === 1
                      ? (
                        <ListCsv
                          selectedList={selectedList}
                          onLeadsCreate={onLeadsCreate}
                          setSnackbarMsg={setSnackbarMsg}
                          setSnackbarOpen={setSnackbarOpen}
                          setIsImportLeadsDialogOpen={setIsImportLeadsDialogOpen}
                          exactTotalCount={selectedListLeads?.total}
                          refetchLeads={refetchLeads}
                          refetchLists={refetchLists}
                        />
                        )
                      : null}
                </DialogContent>
              </Dialog>
              <Box sx={{
                display: 'flex',
                gap: 1,
                justifyContent: 'space-between'
              }}
              >
                <Box sx={{
                  display: 'flex',
                  justifyContent: (masterLists || selectedListLeads?.docs?.length === 0) ? 'center' : 'space-between'
                }}
                >
                  {selectedRows && selectedRows.length > 0 && !masterLists && (
                    <IconButton onClick={handleRowDeleteConfirmation}>
                      <Delete sx={{ color: 'red' }} fontSize='small' />
                    </IconButton>
                  )}
                  {selectedList && !selectedRows.length > 0 && !masterLists && (
                    <IconButton onClick={handleDeleteConfirmation}>
                      <Delete sx={{ color: 'red' }} fontSize='small' />
                    </IconButton>
                  )}

                  {selectedList && !selectedRows.length > 0 && selectedListLeads?.docs?.length > 0 && !masterLists && (
                    <Tooltip title='Download the Selected Leads' arrow placement='top'>
                      <IconButton onClick={() => handleDownloadSelectedLeads(true)}>
                        <Download sx={{ color: 'rgba(0,0,0,0.6)' }} fontSize='small' />
                      </IconButton>
                    </Tooltip>
                  )}

                  {selectedRows.length > 0
                    ? (
                      <Tooltip title='Download the Selected Leads' arrow placement='top'>
                        <IconButton disabled={selectedRows.length === 0} onClick={() => handleDownloadSelectedLeads(false)}>
                          <Download sx={{ color: 'rgba(0,0,0,0.6)' }} fontSize='small' />
                        </IconButton>
                      </Tooltip>
                      )
                    : (<></>)}
                </Box>
                {
                  isSmallScreen
                    ? (
                      <>
                        <IconButton onClick={handleOpenMenu}>
                          <GridMoreVertIcon />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleCloseMenu}
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        >
                          {selectedRows.length > 0 && (
                            <MenuItem onClick={() => {
                              handleConfirmListDownload()
                              handleCloseMenu()
                            }}
                            >
                              Add to List
                            </MenuItem>
                          )}

                          {selectedList && !selectedRows.length && !masterLists && (
                            <MenuItem onClick={() => {
                              handleClickOpenImportLeadsDialog()
                              handleCloseMenu()
                            }}
                            >
                              Import
                            </MenuItem>
                          )}

                          {activeTab === 'people' && (
                            <MenuItem
                              disabled={selectedRows.length === 0}
                              onClick={() => {
                                setAddToCampaignDialogOpen(true)
                                handleCloseMenu()
                              }}
                            >
                              Add to Campaign
                            </MenuItem>
                          )}

                          {activeTab === 'people' && selectedListLeads?.docs?.length > 0 && selectedList && !selectedRows.length && !masterLists && (
                            <MenuItem onClick={() => {
                              handleClickOpen()
                              handleCloseMenu()
                            }}
                            >
                              Enrich Leads
                            </MenuItem>
                          )}

                          {activeTab === 'company' && (
                            <MenuItem
                              disabled={selectedRows.length === 0}
                              onClick={() => {
                                handleNavigateToLeadFinder()
                                handleCloseMenu()
                              }}
                            >
                              Find Employees
                            </MenuItem>
                          )}
                        </Menu>
                      </>
                      )
                    : (
                      <Box
                        sx={{
                          display: 'flex',
                          width: { xs: '100%', sm: '100%', md: '90%', lg: '100%', xl: '100%', xxl: '100%' },
                          justifyContent: (masterLists || selectedListLeads?.docs?.length === 0)
                            ? { xs: 'space-between', sm: 'space-between' }
                            : { xs: 'space-between', sm: 'space-between' }
                        }}
                      >
                        {selectedRows.length > 0
                          ? (
                            <Button
                              sx={{
                                minWidth: { xs: '110px', md: '120px' },
                                p: 0,
                                gap: '6px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                color: 'black',
                                border: '1px solid #E4E4E5',
                                background: theme.palette.primary.contrastText,
                                '&:hover': {
                                  background: '#E1E3EC'
                                },
                                height: { xs: '30px', md: '40px' },
                                '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                                  margin: 0
                                },
                                width: { xs: '100px', md: '110px' },
                                mr: 1
                              }}
                              onClick={handleConfirmListDownload}
                            >
                              <ExportIcon sx={{ height: '16px', width: '16px' }} />
                              <Typography
                                sx={{
                                  // fontSize: '14px',
                                  fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' },
                                  fontWeight: 600,
                                  lineHeight: '17.64px',
                                  letterSpacing: '0em',
                                  color: `${theme.palette.primary.primaryText}`
                                }}
                              >
                                Add to List
                              </Typography>
                            </Button>)
                          : (<></>)}
                        {/* {selectedList && !selectedRows.length > 0 && selectedListLeads?.docs?.length > 0 && !masterLists && (
                              <Tooltip title='Download the Selected Leads' arrow placement='top'>
                                <IconButton onClick={() => handleDownloadSelectedLeads(true)}>
                                  <Download sx={{ color: 'rgba(0,0,0,0.6)' }} fontSize='small' />
                                </IconButton>
                              </Tooltip>
                            )}

                            {selectedRows.length > 0
                              ? (
                                <Tooltip title='Download the Selected Leads' arrow placement='top'>
                                  <IconButton disabled={selectedRows.length === 0} onClick={() => handleDownloadSelectedLeads(false)}>
                                    <Download sx={{ color: 'rgba(0,0,0,0.6)' }} fontSize='small' />
                                  </IconButton>
                                </Tooltip>
                                )
                              : (<></>)} */}
                        {selectedList && !selectedRows.length > 0 && !masterLists && (
                          <Button
                            sx={{
                              display: 'flex',
                              maxWidth: { xs: '80px', md: '70px' },
                              justifyContent: 'center',
                              alignItems: 'center',
                              '&:hover': {
                                backgroundColor: theme?.palette.primary.dark,
                                boxShadow: 10
                              },
                              textAlign: 'left',
                              fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' },
                              fontWeight: 700,
                              lineHeight: '18px',
                              letterSpacing: '0em',
                              color: 'white',
                              backgroundColor: `${theme?.palette.primary.main}`,
                              borderRadius: '8px',
                              py: 1.2,
                              px: 2,
                              height: { xs: '30px', md: '40px' },
                              '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                                margin: 0
                              },
                              width: { xs: '50px' },
                              mr: 1
                            }}
                            disabled={selectedListLeads?.total >= 10000}
                            variant='contained'
                            size='large'
                            onClick={handleClickOpenImportLeadsDialog}
                          >
                            Import
                          </Button>
                        )}
                        {/* ddkjdkdjkdj */}
                        {activeTab === 'people' && (
                          <Button
                            variant='contained'
                            onClick={() => setAddToCampaignDialogOpen(true)}
                            disabled={selectedRows.length === 0}
                            sx={{
                              minWidth: { xs: '120px', md: '150px' },
                              bgcolor: theme.palette.primary.main,
                              '&:hover': {
                                bgcolor: '#1b5cc8'
                              },
                              fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' },
                              p: 0,
                              gap: '6px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              color: '#fff',
                              border: '1px solid #E4E4E5',
                              height: { xs: '30px', md: '40px' },
                              '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                                margin: 0
                              },
                              width: { xs: '130px', md: '30%' },
                              mr: 1
                            }}
                          >
                            Add to Campaign
                          </Button>
                        )}

                        {/* handleEnrichLeadsList */}
                        {activeTab === 'people' && selectedListLeads?.docs?.length > 0 && selectedList && !selectedRows.length > 0 && !masterLists && (
                          <Button
                            variant='contained'
                            onClick={handleClickOpen}
                            sx={{
                              bgcolor: theme.palette.primary.main,
                              '&:hover': {
                                bgcolor: '#1b5cc8'
                              },
                              height: { xs: '30px', md: '40px' },
                              '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                                margin: 0
                              },
                              width: { xs: '50px' },
                              fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' },
                              minWidth: { xs: '105px', md: '120px' },
                              mr: 1
                            }}
                          >
                            Enrich Leads
                          </Button>
                        )}
                        {activeTab === 'company' && (
                          <Button
                            variant='contained'
                            onClick={handleNavigateToLeadFinder}
                            disabled={selectedRows.length === 0}
                            sx={{
                              minWidth: { xs: '120px', md: '150px' },
                              bgcolor: theme.palette.primary.main,
                              '&:hover': {
                                bgcolor: '#1b5cc8'
                              },
                              fontSize: { xs: '12px', sm: '12px', md: '12px', lg: '12px', xl: '12px', xxl: '12px' },
                              p: 0,
                              gap: '6px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              color: '#fff',
                              border: '1px solid #E4E4E5',
                              height: { xs: '30px', md: '40px' },
                              '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                                margin: 0
                              },
                              width: { xs: '130px', md: '30%' },
                              mr: 1
                            }}
                          >
                            Find Employees
                          </Button>
                        )}
                      </Box>
                      )
                }
              </Box>
            </Box>
            {selectedList && selectedListLeads?.docs?.length > 0 &&
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      selectedRows.length > 0 &&
                      selectedListLeads?.docs?.every(row => selectedRows.includes(row._id))
                    }
                    onChange={(e) => {
                      const pageRows = selectedListLeads?.docs || []
                      const pageRowIds = pageRows.map(row => row._id)

                      if (e.target.checked) {
                        setSelectedRows(pageRowIds)
                        setSelectedRowData(pageRows)
                      } else {
                        setSelectedRows([])
                        setSelectedRowData([])
                      }
                    }}
                  />
                }
                label='Select All This Page'
              />}

            {/* DataGrid Box */}
            <Box
              sx={{
                bgcolor: 'white',
                borderRadius: 2,
                boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
                height: selectedList && selectedListLeads?.docs?.length > 0 ? 'calc(100% - 100px)' : 'calc(100% - 60px)'
              }}
            >
              <DataGrid
                {...dataGridProps}
                className={classes.customDataGrid}
                sx={{
                  border: 'none',
                  '& .MuiDataGrid-cell': {
                    borderBottom: '1px solid #E4E4E5'
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    bgcolor: '#F2F4F6',
                    borderBottom: '1px solid #E4E4E5'
                  },
                  '& .MuiDataGrid-footerContainer': {
                    bgcolor: '#F2F4F6', // 👈 Add your desired color here
                    borderTop: '1px solid #E4E4E5'
                  },
                  '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 700,
                    color: theme.palette.primary.primaryText
                  },
                  ...(selectedListLeads?.docs?.length === 0 && {
                    overflowX: 'hidden',
                    '& .MuiDataGrid-virtualScroller': {
                      overflowX: 'hidden'
                    }
                  }),
                  width: '100%',
                  '& .MuiDataGrid-columnSeparator': { display: 'none' },
                  '& .MuiDataGrid-virtualScroller': { marginTop: '-2px' },
                  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
                  },
                  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
                  },
                  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
                  },
                  '& .MuiList-root.MuiMenu-list': {
                    width: '100px'
                  }
                }}
              />
            </Box>
          </Box>

        </Box>

        {/* New List Dialog */}
        <Dialog
          open={newListDialogOpen}
          onClose={() => setNewListDialogOpen(false)}
          PaperProps={{
            sx: {
              borderRadius: 2,
              width: '100%',
              maxWidth: 480
            }
          }}
        >
          <DialogTitle
            sx={{
              fontSize: '20px',
              fontWeight: 700,
              color: theme.palette.primary.primaryText
            }}
          >
            {activeTab === 'people' ? 'Create New People List' : 'Create New Company List'}
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin='dense'
              label='List Name'
              fullWidth
              value={newListName}
              onChange={(e) => setNewListName(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#E4E4E5'
                  },
                  '&:hover fieldset': {
                    borderColor: theme.palette.primary.main
                  }
                }
              }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button
              onClick={() => setNewListDialogOpen(false)}
              variant='outlined'
              sx={{
                borderColor: '#E4E4E5',
                color: theme.palette.primary.primaryText,
                '&:hover': {
                  borderColor: theme.palette.primary.main
                }
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleNewList}
              disabled={!newListName.trim() || isCreating}
              variant='contained'
              sx={{
                bgcolor: theme.palette.primary.main,
                '&:hover': {
                  bgcolor: '#1b5cc8'
                }
              }}
            >
              {isCreating ? <CircularProgress size={24} /> : 'Create'}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openVerified} onClose={handleClose}>
          <DialogTitle>Enrich Leads</DialogTitle>
          <DialogContent>
            <FormControlLabel
              control={
                <Checkbox
                  checked={verified}
                  onChange={handleCheckboxChange}
                  name='verifyLeads'
                />
              }
              label='Would you like to validate the email addresses?'
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={() => handleEnrichLeadsList()}>
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete Confirmation Dialog */}
        <ConfirmationDialog
          open={deleteConfirmationOpen}
          onClose={() => setDeleteConfirmationOpen(false)}
          onConfirm={handleConfirmedDelete}
          title='Confirm Delete'
          content='Are you sure you want to delete this list?'
          confirmText='Delete'
          cancelText='Cancel'
          confirmColor='error'
        />

        <ConfirmationDialog
          open={deleteRowConfirmationOpen}
          onClose={() => setDeleteRowConfirmationOpen(false)}
          onConfirm={handleConfirmedPostRow}
          title='Confirm Delete'
          content="Are you sure you want to delete the selected lead's?"
          confirmText='Delete'
          cancelText='Cancel'
          confirmColor='error'
        />

        {/* Add to Campaign Dialog */}
        <Dialog
          open={addToCampaignDialogOpen}
          onClose={() => setAddToCampaignDialogOpen(false)}
          PaperProps={{
            sx: {
              borderRadius: 2,
              width: '100%',
              maxWidth: 480
            }
          }}
        >
          <DialogTitle
            sx={{
              fontSize: '20px',
              fontWeight: 700,
              color: theme.palette.primary.primaryText
            }}
          >
            Add to Campaign
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Select Campaign</InputLabel>
              <Select
                value={selectedCampaign}
                label='Select Campaign'
                onChange={(e) => setSelectedCampaign(e.target.value)}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 300
                    }
                  }
                }}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#E4E4E5'
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main
                  }
                }}
              >
                {campaigns?.updatedEmail?.map((campaign) => (
                  <MenuItem key={campaign._id} value={campaign._id}>
                    {campaign.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <FormControlLabel
              control={
                <Checkbox checked={verifyLeads} onChange={(e) => setVerifyLeads(e.target.checked)} />
              }
              label='Validate Emails'
              sx={{ mt: 2, display: 'block' }}
            /> */}
            <FormControlLabel
              control={
                <Checkbox
                  icon={<OffCheckboxCustomIcon />}
                  checkedIcon={<OnCheckboxCustomIcon />}
                  checked={leadDuplicate}
                  onChange={(e) => setLeadDuplicate(e.target.checked)}
                />
              }
              label='Remove Duplicates Across Campaigns'
              sx={{
                '& .MuiFormControlLabel-label': {
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: '16px',
                  color: `${theme.palette.primary.primaryText}`
                },
                mt: 2
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  icon={<OffCheckboxCustomIcon />}
                  checkedIcon={<OnCheckboxCustomIcon />}
                  checked={bounceCheck}
                  onChange={(e, value) => setBounceCheck(value)}
                />
              }
              label='Skip Bounced Leads'
              sx={{
                '& .MuiFormControlLabel-label': {
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: '16px',
                  color: `${theme.palette.primary.primaryText}`
                }
              }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button
              onClick={() => setAddToCampaignDialogOpen(false)}
              variant='outlined'
              sx={{
                borderColor: '#E4E4E5',
                color: theme.palette.primary.primaryText,
                '&:hover': {
                  borderColor: theme.palette.primary.main
                }
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleAddToCampaign}
              disabled={!selectedCampaign}
              variant='contained'
              sx={{
                bgcolor: theme.palette.primary.main,
                '&:hover': {
                  bgcolor: '#1b5cc8'
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
        {/* ListDetailModal when we have a selected lead */}
        {isLeadDetailDrawerOpen && (
          <ListDetailModal
            isOpen={isLeadDetailDrawerOpen}
            onClose={handleLeadDetailDrawerClose}
            user={selectedListLeads?.docs?.find((lead) => lead._id === rowClickedId) || null}
            handleAddToListClick={() => {
              handleLeadDetailDrawerClose()
              // list addition logic here
            }}
            handleAddToCampaignClick={() => {
              setIsConfirmingLeads(true)
              // Add the selected lead to the campaign
              const leadToAdd = selectedListLeads?.docs?.find((lead) => lead._id === rowClickedId)
              if (leadToAdd) {
                setSelectedRows([leadToAdd._id])
                setSelectedRowData([leadToAdd])
                handleLeadDetailDrawerClose()
                setAddToCampaignDialogOpen(true)
              }
              setIsConfirmingLeads(false)
            }}
            isConfirmingLeads={isConfirmingLeads}
            activeTab={activeTab}
          />
        )}
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackbarOpen}
          message={snackbarMsg}
          key='csv-import'
          ContentProps={{
            sx: {
              backgroundColor: theme?.palette.primary.main,
              color: theme?.palette.primary.contrastText
            }
          }}
        />

        <Dialog open={openListDialog}>
          <ExportCsvDialog openDialog={openListDialog} handleCloseDialog={handleCloseListDialog} handleDownloadCsvClick={handleDownloadCsvClick} verifyLeads={verifyLeads} setVerifyLeads={setVerifyLeads} list setListId={setListId} listId={listId} listReq selectedList={selectedList} alignment={activeTab === 'people' ? 'People' : 'Companies'} />
        </Dialog>

      </Box>
    </Box>
  )
}

export default LeadsListView
